import { getAppData } from "app/getAppData";
import {
  setPuzzelOrgConfig,
  setPuzzelRuntimeConfig,
} from "app/PuzzelAuth/puzzelAuthConfig";
import { Amplify } from "aws-amplify";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const { cognitoSettings, puzzelSettings } = await getAppData();

  setPuzzelRuntimeConfig({
    clientId: puzzelSettings.clientId,
    idpScheme: puzzelSettings.idpScheme,
  });

  setPuzzelOrgConfig({
    ciqType: puzzelSettings.ciqType,
    phoneNumberPrefix: puzzelSettings.phoneNumberPrefix,
    functionalNumberPrefix: puzzelSettings.functionalNumberPrefix,
    countryCode: puzzelSettings.countryCode,
    maxAttempts: puzzelSettings.maxAttempts,
    maxOneRequestForPreferredAgent:
      puzzelSettings.maxOneRequestForPreferredAgent,
    preferredAgentWaitTimeSeconds: puzzelSettings.preferredAgentWaitTimeSeconds,
    queueKey: puzzelSettings.queueKey,
    reservedAgentWaitTimeSeconds: puzzelSettings.reservedAgentWaitTimeSeconds,
    secondsBetweenAttempts: puzzelSettings.secondsBetweenAttempts,
  });

  const cognitoAuthUrl = cognitoSettings.authUrl;
  const cognitoClientId = cognitoSettings.clientId;
  const cognitoUserPoolId = cognitoSettings.userPoolId;

  if (!cognitoAuthUrl || !cognitoClientId || !cognitoUserPoolId) {
    throw new Error("Missing Cognito configuration in app-data");
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: cognitoAuthUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId: cognitoUserPoolId,
        userPoolClientId: cognitoClientId,
      },
    },
  });

  isConfigured = true;
};
